// Evergreen daily countdown — resets at local midnight. Drives urgency.
import { useEffect, useState } from "react";

const fmt = (n) => String(n).padStart(2, "0");

export default function CPCountdown({ compact = false }) {
  const [t, setT] = useState({ h: 0, m: 0, s: 0 });

  useEffect(() => {
    const tick = () => {
      const now = new Date();
      const end = new Date(now);
      end.setHours(23, 59, 59, 999);
      const diff = Math.max(0, end - now);
      const h = Math.floor(diff / 3.6e6);
      const m = Math.floor((diff % 3.6e6) / 6e4);
      const s = Math.floor((diff % 6e4) / 1000);
      setT({ h, m, s });
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);

  if (compact) {
    return (
      <span data-testid="cp-countdown-compact" className="font-mono font-bold tabular-nums">
        {fmt(t.h)}:{fmt(t.m)}:{fmt(t.s)}
      </span>
    );
  }

  return (
    <div data-testid="cp-countdown" className="flex items-center gap-2 sm:gap-3">
      {[
        { v: t.h, l: "HRS" },
        { v: t.m, l: "MIN" },
        { v: t.s, l: "SEC" },
      ].map((b, i) => (
        <div key={i} className="bg-black/40 border border-[#D4AF37]/40 rounded-sm px-3 py-2 min-w-[60px] text-center backdrop-blur">
          <div className="text-2xl sm:text-3xl font-bold font-mono tabular-nums text-[#D4AF37] leading-none">{fmt(b.v)}</div>
          <div className="text-[9px] sm:text-[10px] uppercase tracking-[0.2em] text-white/60 mt-1">{b.l}</div>
        </div>
      ))}
    </div>
  );
}
